import React, { useEffect, useState } from "react";
import Flag from "react-world-flags";
import Navbar from "../components/Navbar";
import DailyMenuTabs from "../components/DailyMenuTabs";

const HomePage = () => {
  const [alertText, setAlertText] = useState("");

  useEffect(() => {
    fetch("/documents/hlaska.json")
      .then((res) => res.json())
      .then((data) => {
        if (data.text?.trim()) {
          setAlertText(data.text.trim());
        } else {
          setAlertText("");
        }
      })
      .catch(() => setAlertText(""));
  }, []);

  return (
    <div className="min-h-screen bg-neutral-900 text-orange-400 font-sans">
      <Navbar />

      <header className="bg-neutral-800 shadow-md">
        {alertText && (
          <div className="bg-red-900 text-orange-300 font-semibold text-sm text-center py-2">
            {alertText}
          </div>
        )}
      </header>

      <main className="max-w-5xl mx-auto px-4 py-10 space-y-16">
        {/* Obrázek */}
        <section>
          <div className="rounded-xl overflow-hidden shadow-lg border border-neutral-700">
            <img
              src="/img/foto/Venek.jpg"
              alt="Restaurace zvenku"
              className="w-full h-auto"
            />
          </div>
        </section>

        {/* O nás */}
        <section className="bg-neutral-800 rounded-lg shadow-md p-6 border-l-4 border-red-700">
          <h2 className="text-xl font-semibold text-orange-300 mb-2" style={{ textShadow: "1px 1px 2px #7f1d1d" }}>O nás</h2>
          <p className="text-sm leading-relaxed text-gray-200">
          V naší restauraci v Plzni se můžete těšit na pravé chutě indické a nepálské kuchyně. Vše připravujeme podle tradičních receptur s důrazem na čerstvé suroviny a výrazné koření. Nabízíme klidné prostředí, přátelskou obsluhu a jídla, která vás zanesou přímo do srdce Himalájí.

          </p>
        </section>

        {/* Denní menu */}
        <section>
          <DailyMenuTabs />
        </section>

        {/* PDF menu */}
        <section>
          <h2 className="text-lg font-semibold text-orange-400 mb-3 border-l-4 border-red-700 pl-3" style={{ textShadow: "1px 1px 2px #7f1d1d" }}>
            Naše stálé menu
          </h2>
          <div className="hidden md:block border border-neutral-700 rounded overflow-hidden shadow">
            <iframe
              src="/documents/menu.pdf"
              width="100%"
              height="1100px"
              title="Menu PDF"
              className="w-full"
              style={{ border: "none" }}
            />
          </div>
          <div className="md:hidden text-center">
            <a
              href="/documents/menu.pdf"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-block mt-4 bg-red-700 text-white px-5 py-2 rounded shadow hover:bg-red-800 transition"
            >
              Zobrazit PDF menu
            </a>
          </div>
        </section>

        {/* Galerie */}
<section>
  <h2
    className="text-lg font-semibold text-orange-300 mb-4 border-l-4 border-red-700 pl-3"
    style={{ textShadow: "1px 1px 2px #7f1d1d" }}
  >
    Fotogalerie
  </h2>
  <div className="grid gap-4 grid-cols-1 sm:grid-cols-2 md:grid-cols-2">
    {Array.from({ length: 4 }).map((_, i) => (
      <div
        key={i}
        className="rounded overflow-hidden shadow border border-neutral-700"
      >
        <img
          src={`/img/foto/Papu${i + 1}.jpg`}
          alt={`Foto ${i + 1}`}
          className="w-full h-72 object-cover" // zvýšená výška pro větší fotku
        />
      </div>
    ))}
  </div>
</section>

        {/* Kontakt */}
        <section className="grid grid-cols-1 md:grid-cols-2 gap-8">
          <div className="space-y-3">
            <h2 className="text-lg font-semibold text-orange-300 border-l-4 border-red-700 pl-3" style={{ textShadow: "1px 1px 2px #7f1d1d" }}>
              Kontakt
            </h2>
            <p className="text-sm text-gray-300"><strong>Adresa:</strong> Máchova 6, Plzeň</p>
            <p className="text-sm text-gray-300">
              <strong>Otevírací doba:</strong><br />
              Po–So: 11:00–22:00<br />
            </p>
            <p className="text-sm text-gray-300"><strong>Telefon:</strong> <a href="tel:+420373394631" className="text-blue-400 hover:underline">+420 373 394 631</a></p>
            <p className="text-sm text-gray-300"><strong>E-mail:</strong> <a href="mailto:info@namasteindicka.cz" className="text-blue-400 hover:underline">info@namasteindicka.cz</a></p>
          </div>
          <div className="rounded overflow-hidden border border-neutral-700">
          <iframe
  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2563.617344297607!2d13.370001315716037!3d49.74173367937582!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x470afa96955b9a03%3A0xb0ea5021b78f06cb!2sM%C3%A1chova%206%2C%20301%2000%20Plze%C5%88%203-Ji%C5%BEn%C3%AD%20P%C5%99edm%C4%9Bst%C3%AD!5e0!3m2!1scs!2scz!4v1716732010001!5m2!1scs!2scz"
  width="100%"
  height="350"
  style={{ border: 0 }}
  allowFullScreen=""
  loading="lazy"
  referrerPolicy="no-referrer-when-downgrade"
  title="Mapa – Máchova 6, Plzeň"
/>
          </div>
        </section>
      </main>

      <footer className="bg-neutral-800 border-t text-center text-sm py-4 text-gray-400">
        © {new Date().getFullYear()} Restaurace Namaste. Vytvořil DZ-Company.
      </footer>
    </div>
  );
};

export default HomePage;